const { AbortController, abortableFetch } = require('abortcontroller-polyfill/dist/cjs-ponyfill');
const nodeFetch = require('node-fetch');

const defaultFetch = typeof window !== 'undefined' && window.fetch ? window.fetch : nodeFetch;

const { fetch } = abortableFetch({ fetch: defaultFetch });

module.exports = fetch;
module.exports.AbortController = AbortController;
